import { createContext } from "react";
interface ContextState {
  enrolmentSource: string;
  setEnrolmentSource: (source:string) => void;
}

const LayoutContext = createContext({} as ContextState);

export default LayoutContext;

export const { Provider, Consumer } = LayoutContext;
